import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
} from 'devextreme-react/data-grid';
import { Format } from "devextreme-react/number-box";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarNaturezaOperacaoDs } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class NaturezasOperacaoBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Natureza das Operações">
                    <DataGrid
                        dataSource={criarNaturezaOperacaoDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'sequencial'} caption={"#"} width={'150'} allowEditing={false} />
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}></Column>
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Column dataField={'descricaoGuia'} caption={"Descrição Guia"} />

                        <Column dataField={'aliquota'}
                            caption={"Alíquota"}
                            dataType={"number"}
                            editorType={"dxNumberBox"}
                            format={"#,##0.000000"}
                            editorOptions={{ format: "#,##0.000000" }} />

                        <Column dataField={'aliquotaFinanciada'}
                            caption={"Alíquota Financiada"}
                            dataType={"number"}
                            editorType={"dxNumberBox"}
                            format={"#,##0.000000"}
                            editorOptions={{ format: "#,##0.000000" }} />

                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}
